"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllMeetingsTableActions = void 0;
var api_1 = require("../../api");
var components_1 = require("../../components");
var button_1 = require("../../components/button/button");
var utils_1 = require("../../utils");
var AllMeetingsTableActions;
(function (AllMeetingsTableActions) {
    AllMeetingsTableActions["MeetingsLoaded"] = "MeetingsLoaded";
    AllMeetingsTableActions["MeetingDetailButtonClicked"] = "MeetingDetailButtonClicked";
    AllMeetingsTableActions["MeetingDetailClosed"] = "MeetingDetailClosed";
    AllMeetingsTableActions["MeetingDetailFormOpened"] = "MeetingDetailFormOpened";
})(AllMeetingsTableActions || (exports.AllMeetingsTableActions = AllMeetingsTableActions = {}));
var AllMeetingsTable = /** @class */ (function () {
    function AllMeetingsTable(api, currentUserManager, navigator, options) {
        var _this = this;
        var _a, _b, _c, _d;
        this.api = api;
        this.currentUserManager = currentUserManager;
        this.navigator = navigator;
        this.options = options;
        this.goToEventLanding = function (eventId) { return function () {
            _this.navigator.goToEventLanding(eventId);
        }; };
        this.loadExapndedContent = function (meeting) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = meeting;
                        return [4 /*yield*/, this.api.get("".concat(api_1.EndpointUrls.Events, "/").concat(meeting.eventId, "/MeetingTableItemDetail/").concat(meeting.id))];
                    case 1:
                        _a.expandedContent = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.loadEventOptions = function () {
            return _this.api.getEventDropdownOptions()
                .then(function (options) {
                var eventOptions = options.map(function (option) {
                    return {
                        label: "".concat(option.name, " (").concat(utils_1.DateUtils.formatDate(option.startDate, utils_1.DateFormats.YYYY), ")"),
                        value: option.id
                    };
                });
                _this.eventSearchField.setNumberOptions(eventOptions);
            });
        };
        this.loadCustomerCompanyOptions = function () {
            return _this.api.getCustomerCompanyDropdownOptions()
                .then(function (options) {
                var companyOptions = options.map(function (option) {
                    return {
                        label: option.name,
                        value: option.id
                    };
                });
                _this.customerCompanySearchField.setNumberOptions(companyOptions);
            });
        };
        this.loadData = function () {
            return _this.api.getTablePage(api_1.EndpointUrls.Meetings + '/AllMeetings', _this._table.recordsPerPage, _this._table.currentPage, _this._table.sortExpression, _this._table.searchPhrase, __assign({}, _this.listOptionSlideContainer.appliedFiltersModel))
                .then(function (response) {
                _this._meetingDetailForm = null;
                return response;
            });
        };
        this.buildEventLandingButton = function (meeting) {
            return new button_1.default({
                onClick: _this.goToEventLanding(meeting.eventId),
                text: meeting.name
            });
        };
        this.buildMeetingDetailButton = function (meeting, truncateName) {
            var buttonText;
            if (truncateName) {
                buttonText = utils_1.StringUtils.truncate(meeting.name, 25);
            }
            else {
                buttonText = utils_1.StringUtils.truncate(meeting.name, 30);
            }
            var btn = new button_1.default({
                onClick: function () {
                    _this._meetingDetailForm = new components_1.MeetingDetailForm(_this.api, meeting.eventId, _this.navigator, _this.currentUserManager);
                    _this._meetingDetailForm.observationProvider.observe(function () {
                        _this._meetingDetailForm = null;
                        _this.observationProvider.notifyObservers(AllMeetingsTableActions.MeetingDetailClosed);
                    }, components_1.MeetingDetailFormActions.Closed);
                    _this._meetingDetailForm.observationProvider.observeMany(function () {
                        _this.observationProvider.notifyObservers(AllMeetingsTableActions.MeetingDetailFormOpened);
                    }, [components_1.MeetingDetailFormActions.Opened, components_1.MeetingDetailFormActions.Loaded]);
                    _this._meetingDetailForm.open(meeting.id);
                    _this.observationProvider.notifyObservers(AllMeetingsTableActions.MeetingDetailButtonClicked);
                },
                text: buttonText
            });
            btn.setDisabled(_this.table.isLocked);
            return btn;
        };
        this.buildMeetingNotesReportUrl = function (meeting) {
            return '/#' + _this.navigator.urlBuilder.buildMeetingNotesReportPage({ meetingId: meeting.id, meetingUniqueId: meeting.uniqueId });
        };
        this.observationProvider = new utils_1.ObservationProvider();
        this._table = new components_1.Table(this.loadData, api, true, this.loadExapndedContent);
        this._table.searchBoxPlaceholder = 'By customer, company or meeting name';
        this.customerCompanySearchField = new components_1.NumberDropdownField('customerCompanyId', 'Customer Company', false, [], 'required', null, components_1.FieldType.DropDown, 'All Companies');
        this.customerCompanySearchField.setVisibility(this.isCustomerView === false);
        this.userSearchField = new components_1.UserSearchField(this.api, 'Attendees', false, null, true, 'userIds');
        var customerNameSearchField = new components_1.TextField('customerName', 'Customer Name', false, 100);
        customerNameSearchField.setVisibility(this.isCustomerView === false);
        var customerFields = [];
        if (this.isCustomerView === false) {
            customerFields.push(customerNameSearchField);
            customerFields.push(this.customerCompanySearchField);
        }
        var filters = __spreadArray(__spreadArray([
            new components_1.StringDropdownField('isActive', 'Is Active', false, [{ label: 'All', value: '' }, { label: 'Active', value: 'true' }, { label: 'Inactive', value: 'false' }]),
            new components_1.CheckBoxField('myMeetings', 'My meetings'),
            new components_1.CheckBoxField('hasNotes', 'Has Notes'),
            new components_1.TextField('meetingNumber', 'Meeting #', false, 5, null, null, components_1.FieldType.Int),
            new components_1.TextField('meetingName', 'Meeting Name', false, 100),
            new components_1.MeetingStatusField('status', 'Status', false)
        ], customerFields, true), [
            this.userSearchField,
            new components_1.BusinessAreaDropdown(this.api, 'businessAreaId', 'Business Area', false, null),
            new components_1.DepartmentDropdown(this.api, 'departmentId', false),
            new components_1.DateField('startDate', 'Start Date', false),
            new components_1.DateField('endDate', 'End Date', false),
            new components_1.TimeField('eventStartTime', 'Start Time', false),
            new components_1.TimeField('eventEndTime', 'End Time', false),
        ], false);
        this.myNotesSwitchField = new components_1.CheckBoxField('myNotesSearch', 'My Notes');
        this.myNotesSwitchField.observationProvider.observe(function () {
            _this.listOptionSlideContainer.appliedFiltersModel.myNotes = _this.myNotesSwitchField.value;
            _this._table.load();
        }, components_1.FieldActions.ValueChanged);
        this.eventSearchField = new components_1.NumberDropdownField('eventId', 'Event Search', false, [], 'required', null, components_1.FieldType.DropDown, 'All Events');
        this.eventSearchField.observationProvider.observe(function () {
            _this.listOptionSlideContainer.appliedFiltersModel.eventId = _this.eventSearchField.value;
            _this._table.load();
        }, components_1.FieldActions.ValueChanged);
        var defaultFilters = {
            isActive: true,
            myMeetings: this.isCustomerView === false,
            customerCompanyId: (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.customerCompanyId) !== null && _b !== void 0 ? _b : undefined,
            customerId: (_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.customerId) !== null && _d !== void 0 ? _d : undefined
        };
        this.listOptionSlideContainer = new components_1.ListOptionSlideContainer(filters, defaultFilters);
        this.listOptionSlideContainer.observationProvider.observe(function () {
            _this.myNotesSwitchField.setValue(_this.listOptionSlideContainer.appliedFiltersModel.myNotes);
            _this.eventSearchField.setValue(_this.listOptionSlideContainer.appliedFiltersModel.eventId);
            _this._table.load();
        }, components_1.ListOptionSlideContainerActions.OptionsApplied);
        this._table.load();
        this.loadEventOptions();
        this.loadCustomerCompanyOptions();
    }
    Object.defineProperty(AllMeetingsTable.prototype, "table", {
        get: function () {
            return this._table;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AllMeetingsTable.prototype, "meetingDetailForm", {
        get: function () {
            return this._meetingDetailForm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AllMeetingsTable.prototype, "isApp", {
        get: function () {
            return this.currentUserManager.clientChecker.isMobileApp();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AllMeetingsTable.prototype, "isCustomerView", {
        get: function () {
            var _a, _b;
            return !!((_a = this.options) === null || _a === void 0 ? void 0 : _a.customerId) || !!((_b = this.options) === null || _b === void 0 ? void 0 : _b.customerCompanyId);
        },
        enumerable: false,
        configurable: true
    });
    return AllMeetingsTable;
}());
exports.default = AllMeetingsTable;
